export namespace FlightCore {
  export enum TripType {
    RoundTrip = 'ROUNDTRIP',
    OneWay = 'ONEWAY',
  }

  export enum CabinClass {
    Economy = 'economy',
    Premium = 'premiumeconomy',
    Business = 'business',
    First = 'first',
  }

  export enum SortBy {
    Carrie = 'carrier',
    Duration = 'duration',
    Outboundarrivetime = 'outboundarrivetime',
    Outbounddeparttime = 'outbounddeparttime',
    Inboundarrivetime = 'inboundarrivetime',
    Inbounddeparttime = 'inbounddeparttime',
    Price = 'price',
  }

  export enum Directionality {
    Outbound = 'Outbound',
    Inbound = 'Inbound',
  }
}
